import { Page } from 'react-pdf';
import styled from 'styled-components';
import { documentContainerWidth } from '../../utils/constants';
const Container = styled.div `
  width: ${({ customWidth }) => customWidth ? customWidth : documentContainerWidth};
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const DocumentWrapper = styled(Container) `
  height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
  flex-flow: wrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  ${({ usesHTML }) => usesHTML && `width: 800px`}
`;
export const HTMLDocumentWrapper = styled.div `
  & * {
    font-family: 'Times New Roman';
  }
  & > * {
    padding-left: 50pt;
    padding-right: 50pt;
  }
  & table {
    width: 100% !important; // table has width as element.style, so we cannot overwrite it without important
  }
`;
export const PageFrame = styled(Page) `
  :not(:last-of-type) {
    position: relative;
  }
  :not(:last-of-type)::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 50%;
    border-bottom: 1px dashed black;
  }
`;
